<template>
  <button
    class="scroll-top-btn"
    v-show="show"
    @click="scrollToTop"
  >
    <img class="top_icon" src="@/assets/resource/icon/arrow-up_thin.png" alt="top_button"/>
  </button>
</template>
<script setup>
    import { ref, onMounted, onUnmounted } from "vue";

    const SHOW_AT        = 5;
    const show           = ref(false);
    const activeScroller = ref(null);

    const isScrollable = (el) =>
    el && typeof el.scrollTop === "number" && el.scrollHeight > el.clientHeight;

    const getScrollTop = (el) => {
        if (!el) return 0;

        // 문서 스크롤
        if (el === document.documentElement || el === document.body || el === document.scrollingElement) {
            return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        }

        return el.scrollTop || 0;
    };

    const onAnyScroll = (e) => {
        const t = e?.target;

        // 스크롤 이벤트 타겟이 실제 스크롤 컨테이너면 그걸 사용
        const scroller = isScrollable(t)
            ? t
            : (document.scrollingElement || document.documentElement);

        activeScroller.value = scroller;

        const top = getScrollTop(scroller);
        show.value = top > SHOW_AT;
    };

    const scrollToTop = () => {
        const el = activeScroller.value;

        // 문서 스크롤이면 window로
        if (!el || el === document.documentElement || el === document.body || el === document.scrollingElement) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }

        // 내부 컨테이너 스크롤이면 컨테이너로
        el.scrollTo({ top: 0, behavior: "smooth" });
    };

    onMounted(() => {
        // ✅ 캡처(true)로 달면 내부 div 스크롤도 전부 잡힘
        document.addEventListener("scroll", onAnyScroll, true);

        // 초기 상태 반영
        onAnyScroll({ target: document.scrollingElement || document.documentElement });
    });

    onUnmounted(() => {
        document.removeEventListener("scroll", onAnyScroll, true);
    });
</script>
<style scoped>
    .scroll-top-btn{
    position: fixed;
    right: 40px;
    bottom: 56px;
    z-index: 9999;  /* ✅ 다른 요소에 가려지지 않게 */
    border: none;
    border-radius: 999px;
    width: 44px;
    height: 44px;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(0,0,0,.15);
    background: #fff;
    }
    .top_icon{
    width: 20px;
    height: auto;
    }
</style>
